/**
 * /app/trusts/$id/companies — Company / operating-entity holdings (route shell).
 *
 * Screen impl in `./companies-screen.tsx`, lazy-loaded via `lazyRouteComponent`.
 * A deep trust sub-tab (company table + add-company modal), not a first-paint
 * route, so the body leaves the entry bundle (200 kB gzip budget). Same
 * shell+screen pattern as the sibling `./documents.tsx` / `./audit.tsx` tabs.
 * The committed routeTree.gen.ts imports only `Route` from here, so no plugin
 * regen is needed.
 *
 * PFO-01 (2026-08-27): `?add=true` lands with the add-company form already
 * open, so the holding-type switcher can hand you straight from "add a
 * property" into "add a shareholding". See `./properties.tsx` for the pair.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

/** Permissive by construction: anything that is not a recognised truthy value
 *  yields `{}`, so a hand-typed or malformed query can never throw the route. */
function validateAddSearch(search: Record<string, unknown>): { add?: true } {
  const raw = search['add'];
  if (raw === true || raw === 'true' || raw === '1') return { add: true };
  return {};
}

export const Route = createFileRoute('/app/trusts/$id/companies')({
  component: lazyRouteComponent(() => import('./companies-screen'), 'CompaniesScreen'),
  validateSearch: validateAddSearch,
});
